import { FC } from "react";
import "./ServerOffline.scss";

export const ServerOffline: FC = () => {
    return (
        <div className="server-offline">
            <h2>Chat is currently unavailable</h2>
            <h3>Server is offline</h3>
        </div>
    );
};
